<template>
  <div class="loader is-loading"
    :style="size"></div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "30px"
    },
    height: {
      type: String,
      default: "30px"
    }
  },

  computed: {
    size() {
      return {
        width: this.width,
        height: this.height
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.loader {
  margin: 0 auto;
}

</style>
